import { useState, useEffect } from 'react';
import api from '../services/api';

// Cache categories to prevent duplicate fetches
let categoriesCache = {
  data: null,
  timestamp: null,
  promise: null
};

const CACHE_DURATION = 300000; // 5 minutes

export function useTemplateCategories() {
  const [categories, setCategories] = useState(categoriesCache.data || []);
  const [loading, setLoading] = useState(!categoriesCache.data);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async (forceRefresh = false) => {
    const now = Date.now();

    // Return cached data if valid
    if (!forceRefresh &&
        categoriesCache.data &&
        categoriesCache.timestamp &&
        (now - categoriesCache.timestamp) < CACHE_DURATION) {
      setCategories(categoriesCache.data);
      setLoading(false);
      return categoriesCache.data;
    }

    // Return existing promise if request in progress
    if (!forceRefresh && categoriesCache.promise) {
      try {
        const result = await categoriesCache.promise;
        setCategories(result);
        setLoading(false);
        return result;
      } catch (err) {
        setError(err.message);
        setLoading(false);
        throw err;
      }
    }

    // Create new request
    setLoading(true);
    setError(null);

    const promise = api.listTemplateCategories()
      .then((response) => {
        const data = response.categories || [];
        categoriesCache = {
          data,
          timestamp: Date.now(),
          promise: null
        };
        setCategories(data);
        setLoading(false);
        return data;
      })
      .catch((err) => {
        categoriesCache = {
          data: null,
          timestamp: null,
          promise: null
        };
        setError(err.message);
        setLoading(false);
        throw err;
      });

    // Store promise to prevent duplicate requests
    categoriesCache.promise = promise;

    return promise;
  };

  return {
    categories,
    loading,
    error,
    refetch: () => fetchCategories(true)
  };
}